const ACTION_TYPE = {
  view: 'view',
  edit: 'edit',
  delete: 'delete',
  action1: 'action1',
  action2: 'action2',
};

export default ACTION_TYPE;
